import React, { Component } from "react"
import { connect } from "react-redux"
import Title from "../../common/Title"
import InputField from "../../common/InputField"
import { Button } from "../../common/Button"
import Loader from "../../common/Loader"
import { isValidField } from "../../../utils/FieldsValidation"
import Message from "../../common/Message"
import { fetchIfEmpty } from "../../../utils"
import Select from "react-select"
import {
  onStartLoading,
  onCreateOrder,
  closeMessage,
  fetchAllStations,
  fetchAllStationData,
  onFetchExistOrders,
  getDeliveryDetailsFromIsraelPost,
  clearOrderUpdate,
  onCreateOrdersFromFile,
  clearCreateOrdersFromFile,
} from "../../../actions"

import "./style.scss"

class CreateNewOrderScreen extends Component {
  constructor(props) {
    super(props)

    this.INIT_STATE = {
      packageNumber: "",
      mobilePhone: "",
      firstName: "",
      lastName: "",
      showLoading: false,
      stationsList: [],
      stationNumber: "",
      currentStationName: "",
      bagsQuantity: "",
      stationsFiltered: [],
      attachedFile: null,
      isShowCreateOrdersFail: false,
      isShowCreateOrdersSuccess: false,
      errorText: "",

      validField: {
        stationNumber: {
          type: "stationNumber",
          isRequired: true,
          isChecked: false,
          compareMinValue: 1,
          compareMaxValue: 10,
          isValid: false,
        },
        packageNumber: {
          type: "packageNumber",
          isRequired: true,
          isChecked: false,
          compareMinValue: 1,
          compareMaxValue: 30,
          isValid: false,
        },
        mobilePhone: {
          type: "mobile",
          isRequired: true,
          isChecked: false,
          isValid: false,
        },
        firstName: {
          type: "name",
          isRequired: true,
          isChecked: false,
          compareMinValue: 2,
          compareMaxValue: 30,
          isValid: false,
        },
        lastName: {
          type: "name",
          isRequired: true,
          isChecked: false,
          compareMinValue: 2,
          compareMaxValue: 30,
          isValid: false,
        },
        bagsQuantity: {
          type: "bagsQuantity",
          isRequired: true,
          isChecked: false,
          compareMinValue: 1,
          compareMaxValue: 30,
          isValid: false,
        },
      },
    }
    this.state = this.INIT_STATE
  }
  componentDidMount() {
    const {
      authenticated,
      history,
      fetchAllStations,
      orderList,
      stationsList,
      onFetchExistOrders,
    } = this.props

    if (!authenticated) {
      history.push("/")
    }
    this.state = this.INIT_STATE
    fetchIfEmpty(orderList, onFetchExistOrders)
    fetchIfEmpty(stationsList, fetchAllStations)
    if (this.state.stationsFiltered?.length == 0) {
      this.props.fetchAllStationData(this.props.stationsList)
    }
  }

  componentDidUpdate(prevProps) {
    const {
      stationsList,
      stationsItemSelectList,
      israelPostDelivery,
      createOrdersFromFileSuccess,
      createOrdersFromFileFail,
    } = this.props
    const { authenticated, history } = prevProps
    if (!authenticated) {
      history.push("/")
    }
    if (
      israelPostDelivery &&
      prevProps.israelPostDelivery !== israelPostDelivery
    ) {
      this.populateUserFieldsByPackage()
    }
    if (prevProps.stationsList !== stationsList) {
      this.setState({
        stationsList: [...stationsList],
        currentStationName: stationsList[0]?.stationName,
      })
      if (stationsList && stationsItemSelectList.length == 0) {
        this.props.fetchAllStationData(stationsList)
      }
    }
    if (
      stationsItemSelectList &&
      stationsItemSelectList.length == 1 &&
      this.state.stationNumber == ""
    ) {
      this.setState({ stationNumber: stationsItemSelectList[0] })
    }
    // if (
    //   stationsItemSelectList &&
    //   stationsItemSelectList.length > 0 &&
    //   prevProps.stationsItemSelectList.length != stationsItemSelectList.length
    // ) {
    //   this.selectStation()
    // }
    if (createOrdersFromFileSuccess) {
      const failedOrders = this.checkForFailedOrders()
      this.setState({ failedOrdersList: failedOrders })
      this.generateResponseMsg(failedOrders)
    }
    if (createOrdersFromFileFail) {
      this.props.clearCreateOrdersFromFile()
      this.setState({ isShowCreateOrdersFail: true })
    }
  }

  componentWillUnmount() {
    this.state = this.INIT_STATE
  }

  generateResponseMsg(failedOrders) {
    let msg = ""
    this.props.clearCreateOrdersFromFile()
    if (failedOrders.length == 0) {
      this.setState({ isShowCreateOrdersSuccess: true })
      return
    }
    if (
      failedOrders.length == this.props.createOrdersFromFileResponse.data.length
    ) {
      this.setState({ isShowCreateOrdersFail: true })
      return
    }
    if (failedOrders.length > 0) {
      msg = "ההזמנות הבאות נכשלו: "
      failedOrders.forEach((order) => {
        msg += order + ", "
      })
      msg = msg.substring(0, msg.length - 2)
      this.setState({ errorText: msg, isShowCreateOrdersSuccess: true })
      return
    }
  }

  checkForFailedOrders() {
    const { createOrdersFromFileResponse } = this.props
    let failedOrdersList = []
    if (createOrdersFromFileResponse?.data.length > 0) {
      createOrdersFromFileResponse?.data.forEach((order) => {
        if (order.status === false) {
          failedOrdersList.push(order.packageNumber)
        }
      })
    }
    return failedOrdersList
  }

  setValue(inputName, e) {
    switch (inputName) {
      case "packageNumber":
        this.setState({ packageNumber: e.target.value })
        break
      case "mobilePhone":
        this.setState({ mobilePhone: e.target.value })
        break
      case "firstName":
        this.setState({ firstName: e.target.value })
        break
      case "lastName":
        this.setState({ lastName: e.target.value })
        break
      case "bagsQuantity":
        this.setState({ bagsQuantity: e.target.value })
        break
      default:
        break
    }
  }

  // selectStation() {
  //   const { selectedStation, stationsItemSelectList } = this.props
  //   if (selectedStation && stationsItemSelectList) {
  //     var result = stationsItemSelectList.find((obj) => {
  //       return obj.value === selectedStation
  //     })
  //     if (result) {
  //       this.setState({ stationsFiltered: result, stationNumber: result })
  //       return
  //     }
  //   }
  //   this.setState({
  //     stationsFiltered: stationsItemSelectList,
  //   })
  // }

  onInputFocus(inputName) {
    let { validField } = this.state
    let field = validField[inputName]
    if (!field) return

    field.isChecked = false
    field.isValid = false
    validField[inputName] = field

    this.setState({
      ...this.state,
      validField,
    })
  }

  validateInputValue(inputName, value) {
    let { validField } = this.state
    let field = validField[inputName]
    if (!field) return

    field.isChecked = true
    field.isValid = isValidField(
      value,
      field.type,
      field.isRequired,
      field.compareMinValue,
      field.compareMaxValue
    )
    validField[inputName] = field

    this.setState({
      ...this.state,
      validField,
    })
  }

  isValidForm(order) {
    const { validField } = this.state
    this.validateInputValue("stationNumber", order.stationNumber)
    this.validateInputValue("packageNumber", order.packageNumber)
    this.validateInputValue("mobilePhone", order.mobilePhone)
    this.validateInputValue("firstName", order.firstName)
    this.validateInputValue("lastName", order.lastName)
    this.validateInputValue("bagsQuantity", order.bagsQuantity)
    const isValid =
      validField.packageNumber.isChecked &&
      validField.packageNumber.isValid &&
      validField.mobilePhone.isChecked &&
      validField.mobilePhone.isValid &&
      validField.firstName.isChecked &&
      validField.firstName.isValid &&
      validField.lastName.isChecked &&
      validField.lastName.isValid &&
      validField.stationNumber.isChecked &&
      validField.stationNumber.isValid &&
      validField.bagsQuantity.isChecked
    return isValid
  }

  setOrderStatus() {
    if (this.props.userData && this.props.userData.role == "GeffenMedical") {
      return 19
    }
    return 3
  }

  onClickCreateOrder() {
    const {
      stationNumber,
      packageNumber,
      mobilePhone,
      firstName,
      lastName,
      bagsQuantity,
    } = this.state
    if (
      !this.isValidForm({
        stationNumber,
        packageNumber,
        mobilePhone,
        firstName,
        lastName,
        bagsQuantity,
      })
    ) {
      return
    }
    const orderStatus = this.setOrderStatus()
    this.props.clearOrderUpdate()
    this.props.onCreateOrder(
      stationNumber.value,
      packageNumber,
      mobilePhone,
      firstName,
      lastName,
      orderStatus,
      bagsQuantity ? bagsQuantity : 0
    )
  }

  onMessageCkickOk(e) {
    const { isError } = this.props
    if (isError) {
      this.props.closeMessage()
      return
    }

    this.props.closeMessage()
    this.setState({
      packageNumber: "",
      mobilePhone: "",
      firstName: "",
      lastName: "",
      stationNumber: "",
      bagsQuantity: "",
    })
  }

  clearCreateOrdersFromFile() {
    this.props.clearCreateOrdersFromFile()
    this.setState({
      isShowCreateOrdersFail: false,
      isShowCreateOrdersSuccess: false,
      errorText: "",
    })
  }

  findUserByMobilePhone(orderList, mobilePhone) {
    return orderList.find((order) => {
      if (order.mobilePhone === mobilePhone) {
        return order
      }
    })
  }

  populateUserFieldsByMobile(e) {
    const { orderList } = this.props
    const mobilePhone = e.target.value
    this.setValue("mobilePhone", e)

    if (mobilePhone.length == 10) {
      if (orderList && orderList.length > 0) {
        const order = this.findUserByMobilePhone(orderList, mobilePhone)
        if (order) {
          this.setState({
            firstName: order.firstName,
            lastName: order.lastName,
            stationNumber: this.setDefaultStation(order.stationNumber),
          })
        }
      }
    }
  }

  populateUserFieldsByPackage() {
    const { fName, lName, phone, stationNumber } = this.props.israelPostDelivery

    this.setState({
      firstName: fName,
      lastName: lName,
      mobilePhone: phone,
      stationNumber: this.setDefaultStation(stationNumber),
    })
  }

  setDefaultStation(stationNumber) {
    const { stationsFiltered } = this.state
    if (stationsFiltered.length == 1) {
      return stationsFiltered[0]
    }
    const station = stationsFiltered.find(
      (option) => option.value === stationNumber
    )
    return station ? station : this.state.stationNumber
  }

  onChangePackageNumberHandle(e) {
    const packageNumber = e.target.value
    this.setValue("packageNumber", e)
    if (packageNumber.length == 13 && this.props.userData.role != "Decathlon") {
      this.props.getDeliveryDetailsFromIsraelPost(packageNumber)
    }
  }

  handleFileChange(e) {
    const file = e.target.files[0]
    this.props.onCreateOrdersFromFile(file, 32, 19)
  }

  render() {
    const {
      validField,
      stationNumber,
      packageNumber,
      mobilePhone,
      firstName,
      lastName,
      stationsFiltered,
      bagsQuantity,
      isShowCreateOrdersSuccess,
      isShowCreateOrdersFail,
      errorText,
    } = this.state

    const showSubmitButton = true
    const { showMessage, isError, isLoading } = this.props

    if (isLoading) {
      return (
        <div>
          <Title text="יצירת הזמנה חדשה" />
          <Loader show={isLoading} />
        </div>
      )
    }

    return (
      <div className="create-order">
        <Title text="יצירת הזמנה חדשה" />
        <InputField
          isFocused={true}
          show={true}
          value={packageNumber}
          placeholder="מספר חבילה"
          mandatory={true}
          showValidation={validField.packageNumber.isChecked}
          showValidationOk={validField.packageNumber.isValid}
          showValidationError={!validField.packageNumber.isValid}
          validationErrorMessage="מספר חבילה לא תקין"
          onFocus={(e) => this.onInputFocus("packageNumber")}
          onBlur={(e) =>
            this.validateInputValue("packageNumber", e.target.value)
          }
          onChange={(e) => this.onChangePackageNumberHandle(e)}
          maxLength={30}
        />
        <InputField
          show={true}
          value={mobilePhone}
          placeholder="מספר טלפון"
          mandatory={true}
          showValidation={validField.mobilePhone.isChecked}
          showValidationOk={validField.mobilePhone.isValid}
          showValidationError={!validField.mobilePhone.isValid}
          validationErrorMessage="מספר טלפון לא תקין"
          onFocus={(e) => this.onInputFocus("mobilePhone")}
          onBlur={(e) => this.validateInputValue("mobilePhone", e.target.value)}
          onChange={(e) => this.populateUserFieldsByMobile(e)}
          maxLength={10}
        />
        <InputField
          show={true}
          value={firstName}
          iconStyle=""
          placeholder="שם פרטי"
          mandatory={true}
          showValidation={validField.firstName.isChecked}
          showValidationOk={validField.firstName.isValid}
          showValidationError={!validField.firstName.isValid}
          validationErrorMessage="שם פרטי לא תקין"
          onFocus={(e) => this.onInputFocus("firstName")}
          onBlur={(e) => this.validateInputValue("firstName", e.target.value)}
          onChange={(e) => this.setValue("firstName", e)}
          maxLength={30}
        />
        <InputField
          show={true}
          value={lastName}
          iconStyle=""
          placeholder="שם משפחה"
          mandatory={true}
          showValidation={validField.lastName.isChecked}
          showValidationOk={validField.lastName.isValid}
          showValidationError={!validField.lastName.isValid}
          validationErrorMessage="שם משפחה לא תקין"
          onFocus={(e) => this.onInputFocus("lastName")}
          onBlur={(e) => this.validateInputValue("lastName", e.target.value)}
          onChange={(e) => this.setValue("lastName", e)}
          maxLength={30}
        />
        {this.props.userData.accountType == "CheapSim" ? (
          <InputField
            show={true}
            value={bagsQuantity}
            iconStyle=""
            placeholder="כמות"
            mandatory={true}
            showValidation={validField.bagsQuantity.isChecked}
            showValidationOk={validField.bagsQuantity.isValid}
            showValidationError={!validField.bagsQuantity.isValid}
            validationErrorMessage="שדה חובה"
            onFocus={(e) => this.onInputFocus("bagsQuantity")}
            onBlur={(e) =>
              this.validateInputValue("bagsQuantity", e.target.value)
            }
            onChange={(e) => this.setValue("bagsQuantity", e)}
            type="number"
          />
        ) : null}
        <Select
          value={stationNumber}
          className="station-selector"
          placeholder="עמדה"
          options={this.props.stationsList}
          onChange={(itm) => this.setState({ stationNumber: itm })}
        />
        {validField.stationNumber.isChecked &&
        !validField.stationNumber.isValid ? (
          <div className="station-number-error">
            <span className="fa fa-times-circle"></span>
            <span>אנא בחר עמדה</span>
          </div>
        ) : null}

        <div className="buttons-wrapper">
          <Button onClick={(e) => this.onClickCreateOrder()}>צור הזמנה</Button>
          <Button onClick={(e) => this.props.history.goBack()}> חזור</Button>
          {this.props.userData?.accountType == "TandI" ? (
            <div>
              <label
                className="fileInputButton"
                onChange={(e) => this.handleFileChange(e)}
                htmlFor="ordersFile"
              >
                <input name="" type="file" id="ordersFile" hidden />
                טען קובץ
              </label>
              {isLoading ? "LoadingIndicator..." : null}
            </div>
          ) : null}
        </div>

        <Message
          show={showMessage}
          isError={isError}
          successText="ההזמנה הוספה בהצלחה"
          errorText="הוספת הזמנה נכשלה"
          onClick={(e) => this.onMessageCkickOk(e)}
        />
        <Message
          show={isShowCreateOrdersSuccess}
          isError={isError}
          successText={
            <div>
              הזמנות נוספו בהצלחה{" "}
              {errorText ? (
                <div className="failed-orders">{errorText}</div>
              ) : (
                ""
              )}
            </div>
          }
          errorText=""
          onClick={() => this.clearCreateOrdersFromFile()}
        />
        <Message
          show={isShowCreateOrdersFail}
          isError={true}
          successText=""
          errorText=" הוספת הזמנה נכשלה"
          onClick={() => this.clearCreateOrdersFromFile()}
        />
      </div>
    )
  }
}

const mapStateToProps = ({ users, orders, station, israelPost }) => {
  const { authenticated, userData } = users
  const {
    showMessage,
    isError,
    isLoading,
    orderList,
    createOrdersFromFileSuccess,
    createOrdersFromFileFail,
    createOrdersFromFileResponse,
  } = orders
  const { stationsList, stationsItemSelectList, selectedStation } = station
  const { israelPostDelivery } = israelPost
  return {
    authenticated,
    showMessage,
    isError,
    isLoading,
    stationsList,
    userData,
    orderList,
    stationsItemSelectList,
    israelPostDelivery,
    selectedStation,
    createOrdersFromFileSuccess,
    createOrdersFromFileFail,
    createOrdersFromFileResponse,
  }
}

export default connect(mapStateToProps, {
  onStartLoading,
  onCreateOrder,
  closeMessage,
  fetchAllStations,
  fetchAllStationData,
  onFetchExistOrders,
  getDeliveryDetailsFromIsraelPost,
  clearOrderUpdate,
  onCreateOrdersFromFile,
  clearCreateOrdersFromFile,
})(CreateNewOrderScreen)
